(async () => {
  await loadSnowPreset(tsParticles);

  const screenWidth: number = window.innerWidth;
  const density = screenWidth > 800 ? 1500 : 600;

  await tsParticles.load({
    id: "tsparticles-target",
    options: {
      background: {
        opacity: 0
      },
      particles: {
        move: {
          speed: 1.5
        },
        number: {
          value: density
        },
        size: {
          value: 2
        },
        wobble: { enable: false },
      },
      smooth: true,
      fullScreen: true,
      preset: "snow",
    },
  });
})();
